<div class="paper-snackbar">
  {{ message }}
  @for (action of actions; track action) {
    <div>
      <button class="action" (click)="activeModal.close(action)">{{ action }}</button>
    </div>
  }
</div>
